class Search {
    constructor(element) {
        this.el = element;

        this.init();
    }

    init() {
        this.el.addEventListener("focus", this.openSearch);
        this.el.addEventListener("blur", this.closeSearch.bind(this));
    }

    openSearch() {
        const containers = document.querySelectorAll(".site-header__inner");

        containers.forEach((element) => {
            element.classList.add("search-open");
        });
    }

    closeSearch(e) {
        const submitted =
            e.relatedTarget &&
            e.relatedTarget.classList.contains("search-submit");

        // Only close the search if the target isn't the search submit button
        if (!submitted) {
            const containers = document.querySelectorAll(".site-header__inner");

            containers.forEach((element) => {
                element.classList.remove("search-open");
            });
            this.el.value = "";
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const searchElements = document.querySelectorAll(
        ".site-header__inner .search-input",
    );

    searchElements.forEach((element) => {
        new Search(element);
    });

    // Add focus listener to header buttons to close expanded search box while using tab-key navigation
    let header_buttons = document.querySelectorAll(".btn--icon");
    let containers = document.querySelectorAll(".site-header__inner");
    header_buttons.forEach((item) => {
        item.addEventListener("focus", () => {
            containers.forEach((element) => {
                element.classList.remove("search-open");
            });
        });
    });
});
